import { useCallback } from 'react';
import useMap from '@alltrails/maps/hooks/useMap';
import type { StreetAddressResult } from '@alltrails/types/AlgoliaResults';
import { handleStreetAddressResultSelect } from '@/utils/handleStreetAddressResultSelect';
import { useAppDispatch } from '@/utils/redux';

const useStreetAddressSelect = () => {
  const dispatch = useAppDispatch();
  const map = useMap();

  const handleAddressSelect = useCallback(
    (result?: StreetAddressResult) => {
      if (result) {
        handleStreetAddressResultSelect(result, dispatch, map);
      }
    },
    [dispatch, map]
  );

  return handleAddressSelect;
};

export default useStreetAddressSelect;
